import { useEffect, useState } from 'react';
import { fetchMobilityServices } from '../api';
import { EMPTY_MOBILITY_CONFIG, resolveMobilityConfig } from '../config/mobility-buttons';

/**
 * Loads mobility config from the public API.
 * @param {React.MutableRefObject<boolean>} previewReceivedRef
 */
export function useMobilityApiConfig(previewReceivedRef) {
  const [config, setConfig] = useState(EMPTY_MOBILITY_CONFIG);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const apiConfig = await fetchMobilityServices();
        if (!cancelled && !previewReceivedRef.current) {
          setConfig(resolveMobilityConfig(apiConfig));
          setError(null);
        }
      } catch (err) {
        if (!cancelled && !previewReceivedRef.current) {
          console.warn('[Mobility] Failed to load API config.', err);
          setConfig(EMPTY_MOBILITY_CONFIG);
          setError(err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [previewReceivedRef]);

  return { config, loading, error };
}
